import { apiPost } from "../../../services/api";

export interface FinanceEventPayload {
  source?: string;
  ref_id?: string | null;
  debit?: number;
  credit?: number;
  description?: string;
  meta?: Record<string, unknown>;
}

/**
 * Central financial event emitter
 * Single source of truth for all financial transactions
 */
export async function emitFinanceEvent(event: FinanceEventPayload): Promise<boolean> {
  const payload = {
    date: new Date().toISOString(),
    source: event.source,
    ref_id: event.ref_id || null,
    debit: Number(event.debit || 0),
    credit: Number(event.credit || 0),
    description: event.description || "",
    meta: event.meta || {}
  };

  try {
    await apiPost("/api/finance/events", payload);
    return true;
  } catch (e) {
    console.error("Finance event failed", payload, e);
    return false;
  }
}
